<template>
<div v-if="userList">
  <v-toolbar color="primary" dark>
    <v-icon>group</v-icon>
    <v-toolbar-title ml-3>
      <span>User List</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn outline flat class="primary" @click="createUserDialog = true" @closeDialog="createUserDialog = true">
      Create User<v-icon right>person_add</v-icon>
    </v-btn>
  </v-toolbar>
  <v-card>
    <v-card-title>
      <!-- <v-btn color="primary" @click="createUserDialog = true" @closeDialog="createUserDialog = true">Create User</v-btn> -->
      <v-layout row wrap>
        <v-flex sm8 xs12>
          <v-btn class="primary" @click="showInactiveUsers = !showInactiveUsers"><v-icon left>{{showInactiveUsers ? 'visibility_off' : 'visibility'}}</v-icon>{{showInactiveUsers ? 'Hide Inactive Users' : 'Show Inactive Users'}}</v-btn>
        </v-flex>
      <!-- Search Bar -->
        <v-flex sm4 xs12>
          <v-spacer></v-spacer>
          <v-text-field hide-actions v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-data-table :headers="headers" :loading="this.userList.length > 0 ? false : true" :items="userList" :search="search" item-key="name" hide-actions>
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">{{ props.header.text }}</span>
          <span>{{ props.header.text }}</span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <tr style="cursor: pointer">
        <td @click="userClick(props.item)" class="title"><v-icon style="margin-right: 10px">person</v-icon>{{ props.item.first_name }} {{ props.item.last_name }}</td>
        <td @click="userClick(props.item)" class="title"><v-icon style="margin-right: 10px">email</v-icon>{{ props.item.email }}</td>
        <td @click="userClick(props.item)" class="title"><v-icon style="margin-right: 10px">phone</v-icon>{{ formatPhoneNumber(props.item.phone_1) }}</td>
        <td @click="userClick(props.item)" class="title" ><v-icon style="margin-right: 10px">people</v-icon>{{ props.item.role }}</td>
        <td class="justify-center layout px-0"><v-icon medium @click="deletePrep(props.item)">{{ showInactiveUsers ? 'visibility' : 'visibility_off' }}</v-icon></td>
        </tr>
      </template>
    </v-data-table>
    <!-- Create New User Dialog -->
    <v-dialog max-width="800px" v-model="createUserDialog">
      <create-user v-if="createUserDialog" @closeDialog="createUserDialog = false; selectedUser = null" :editUser="selectedUser"/>
    </v-dialog>
    <!-- End: Create New User Dialog -->
    </v-card>
    <!-- Remove User Dialog -->
    <v-dialog v-model="removeUserDialog" persistent max-width="240">
      <v-card>
        <v-card-title class="headline red--text">Are you sure?</v-card-title>
        <v-card-text v-if="!showInactiveUsers">You are about to make the user <strong>{{ removeUserDialogProps.first_name }} {{ removeUserDialogProps.last_name }}</strong> INACTIVE, would you like to continue? <p><br>Note that user will be removed from all currently active projects.</p></v-card-text>
        <v-card-text v-if="showInactiveUsers">You are about to re-activate the user <strong>{{ removeUserDialogProps.first_name }} {{ removeUserDialogProps.last_name }}</strong>, would you like to continue? <p><br>They will have immediate access to the system.</p></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click.native="removeUserDialog = false">Cancel</v-btn>
          <v-btn v-if="!showInactiveUsers" color="primary" flat @click.native="removeUser">Continue</v-btn>
          <v-btn v-if="showInactiveUsers" color="primary" flat @click.native="activateUser">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Remove User Dialog -->
  </div>
</template>

<script>
import CreateUser from './CreateUser'

export default {
  name: 'Users',
  data () {
    return {
      selectedUser: null,
      createUserDialog: false,
      search: '',
      removeUserDialog: null,
      userFilters: null,
      showInactiveUsers: false,
      userToDelete: null,
      removeUserDialogProps: {first_name: null, last_name: null},
      headers: [
        { text: 'Name', align: 'left', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Phone', value: 'phone' },
        { text: 'Role', value: 'role' },
        { text: '', value: 'delete' },
        // Hidden Headers Used For Search
        { text: 'first_name', class: ['hidden-sm-and-up', 'hidden-xs-only'], value: 'first_name' }
      ]
    }
  },
  components: {
    CreateUser
  },
  computed: {
    userList () {
      let activeUsers = this.$store.getters.userList
      let inactiveUsers = this.$store.getters.inactiveUsers
      if (this.showInactiveUsers) {
        return inactiveUsers
      } else {
        return activeUsers
      }
    }
  },
  methods: {
    removeUser () {
      this.$store.dispatch('deleteUser', this.userToDelete)
      this.removeUserDialog = false
    },
    activateUser () {
      this.$store.dispatch('activateUser', this.userToDelete)
      this.removeUserDialog = false
    },
    deletePrep (user) {
      this.userToDelete = user
      this.removeUserDialogProps.first_name = user.first_name
      this.removeUserDialogProps.last_name = user.last_name
      this.removeUserDialog = true
    },
    userClick (userData) {
      this.selectedUser = Object.assign({}, userData)
      this.createUserDialog = true
    },
    formatPhoneNumber (value) {
      let s2 = ('' + value).replace(/\D/g, '')
      let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
      return (!m) ? null : '(' + m[1] + ')' + ' ' + m[2] + '-' + m[3]
    }
  }
}
</script>

<style scoped>
.header {
  float: left;
  margin-bottom: 40px;
}
.createButton {
  float: right;
}
table.table tbody td {
  cursor: pointer;
  font-size: 20px;
  text-align: left;
}
.icon {
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/users/Users.vue